module.exports = __webpack_public_path__ + "static/media/homeshowlogos-03.0b159feb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeshowlogos-03.jpg
// module id = 377
// module chunks = 0